module.exports = __webpack_public_path__ + "img/removeMin.4e62fbe5.png";